import { getEncryptParams } from 'src/keycloak';
import { DataApiInputParams } from 'src/types/api';
import {
  Builder,
  appendFormData,
  decryptResponse,
  getHeaders,
  getQueryString,
  serializeErrorResponse
} from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';
import { getPayload } from 'src/utils/encryption';

export default (builder: Builder) => {
  return {
    getAssistantHistory: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `mini-experts/assistants?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    getAssistant: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `mini-experts/assistants?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    getAllAssistants: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let tempParams: any = {
          ...arg.params,
          fetch_all:
            arg.params?.fetch_all === undefined ? true : arg.params?.fetch_all
        };
        const url = `mini-experts/assistant_details_service?${getQueryString(
          tempParams
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Assistant']
    }),
    getAssistantDetail: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let tempParams: any = {
          ...arg.params,
          fetch_all:
            arg.params?.fetch_all === undefined ? true : arg.params?.fetch_all
        };
        const url = `mini-experts/assistant_details_service?${getQueryString(
          tempParams
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    createAssistant: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        let formData = appendFormData(arg.params);
        let url = `mini-experts/assistants`;
        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Assistant']
    }),
    deleteAssistant: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let formData = appendFormData(arg.params);
        let url = `mini-experts/assistants`;
        return fetchWithBQ({
          url: url,
          method: 'DELETE',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Favourites']
    }),
    updateAssistant: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        let formData = appendFormData(arg.params);

        let url = `mini-experts/assistants`;
        return fetchWithBQ({
          url: url,
          method: 'PATCH',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Assistant', 'Favourites']
    }),
    getAssistantContentAccessRights: builder.query({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const queryString = getQueryString(arg.params);
        let url = `mini-experts/assistant-perms-details${
          queryString.length ? '?' + queryString : ''
        }`;

        if (IS_ENCRYPTION_ENABLED) {
          url = `${url}${queryString.length ? '&' : '?'}payload=${btoa(
            getPayload('', getEncryptParams())
          )}`;
        }
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    updateAssistantResource: builder.mutation({
      async queryFn({ params }, { getState }, extraOptions, baseQuery) {
        let formData = appendFormData(params);
        return baseQuery({
          url: `mini-experts/assistant-perms-details`,
          method: 'POST',
          body: formData,
          ...getHeaders(`mini-experts/assistant-perms-details`, formData)
        });
      },
      invalidatesTags: ['Assistant']
    })
  };
};
